import React from "react";

import s from "./links.module.scss";
import { MutedDiv, Paragraph, DivEm, DivPx } from "@moai/core";
import { Version } from "./version/version";

const TPLink = () => (
    <span>
        <span>© 2022 </span>
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://tableplus.com"
        >
            TablePlus Inc.
        </a>
    </span>
);

interface Props {
    offlineMode: boolean;
}

export const Links = (props: Props) => (
    <MutedDiv>
        <div className={s.container}>
            <Paragraph>
                <a href="mailto:nick@tableplus.com">Email us</a>
                <DivEm />
                <a
                    rel="noopener noreferrer"
                    href="https://github.com/TablePlus/Toolkit"
                >
                    Issue tracker
                </a>
                {/* There's an Em inside Version */}
                <Version enabled={props.offlineMode} />
                <span className={s.tptop}>
                    <DivEm />
                    <TPLink />
                </span>
            </Paragraph>
            <div className={s.space}>
                <DivPx size={16} />
            </div>
            <Paragraph>
                <span className={s.tpbot}>
                    <TPLink />
                </span>
                <span> </span>
                <span className={s.nobreak}>1100-1959 Upper Water Street</span>
                <span> </span>
                <span className={s.nobreak}>Halifax NS Canada.</span>
                <span> </span>
                <span className={s.nobreak}>All rights reserved</span>
            </Paragraph>
        </div>
    </MutedDiv>
);
